/*
 * @Author: LiuMeiYu
 * @Date: 2022-03-03 17:09:34
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2022-12-26 10:36:54
 * @FilePath: \Nivara\src\store\index.js
 * @Description: *
 * *
 * Copyright (c) 2022 by yihua, All Rights Reserved.
 */
import { createStore } from 'vuex'

export default createStore({
  state: {
    currency_symbol: localStorage.getItem("currency_symbol") || "₦",
  },
  mutations: {
    setCurrencySymbol(state, value) {
      state.currency_symbol = value;
    },
  },
  actions: {
  },
  modules: {
  }
})
